import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { TaxStatus } from './tax-status.interface';
import { TaxStatusService } from './tax-status.service';

const service = new TaxStatusService();

export interface TaxStatusState {
   taxStatuses: Array<TaxStatus>;
}

const TaxStatusStore: Module<TaxStatusState, StoreState> = {
   namespaced: true,
   state: {
      taxStatuses: [],
   },
   getters: {
      taxStatuses(state) {
         return state.taxStatuses;
      },
   },
   mutations: {
      setTaxStatuses(state, taxStatuses: Array<TaxStatus>) {
         state.taxStatuses = taxStatuses;
      },
   },
   actions: {
      async getTaxStatuses(context: any) {
         return await service.getTaxStatuses().then((taxStatuses) => {
            context.commit('setTaxStatuses', taxStatuses);
            return taxStatuses;
         });
      },
   },
};

export default TaxStatusStore;
